
import { defineComponent } from "vue";

export default defineComponent({
  name: "TextInputComponent",
  components: {},

  data() {
    return {
      value: "",
    };
  },

  methods: {
    update(event: Event) {
      console.log(event);
      this.$emit("onUpdate", this.inputID, this.value);
    },
  },

  setup(props) {
    console.log(props);
  },

  props: {
    required: {
      required: false,
      type: Boolean,
    },
    maxLength: {
      required: false,
      type: Number,
    },
    minLength: {
      required: false,
      type: Number,
    },
    label: {
      required: true,
      type: String,
    },
    inputID: {
      required: true,
      type: String,
    },
    isDisabled: {
      type: Boolean,
    },
  },

  emits: ["onUpdate"],
});
